<template>
  <div>
    <div
      id="setup-connection-modal"
      class="modal fade"
      data-backdrop="static"
      role="dialog"
      aria-labelledby="setup-connection-modal-label"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="setup-connection-modal-label"
              class="modal-title"
            >
              Setup Salsify Connection
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="handleClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card w-100">
              <div class="card-body">
                <div class="form-group">
                  <label for="organization-id">Organization ID</label>
                  <input
                    v-model="organizationId"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.organizationId }"
                    placeholder="Enter organization ID"
                  >
                  <small
                    v-if="errors.organizationId"
                    class="text-danger"
                  >
                    {{ errors.organizationId }}
                  </small>
                </div>
                <div class="form-group">
                  <label for="auth-token">API Key</label>
                  <input
                    v-model="authToken"
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': errors.authToken }"
                    placeholder="Enter API Key"
                  >
                  <small
                    v-if="errors.authToken"
                    class="text-danger"
                  >
                    {{ errors.authToken }}
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <div>
              <a
                href="#"
                class="info-btn"
                @click="showInfoModal"
              >
                Where do I find this information?
              </a>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-secondary"
                @click="handleClose"
              >
                Close
              </button>
              <button
                type="button"
                class="btn btn-primary"
                :disabled="isLoading"
                @click="handleConfirm"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="salsify-info-modal"
      class="modal fade"
      role="dialog"
      aria-labelledby="salsify-info-modal-label"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5
              id="salsify-info-modal-label"
              class="modal-title"
            >
              How to Find Salsify API Information
            </h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="hideInfoModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img
              src="/images/salsify/info-hint.webp"
              alt="Salsify API Information Guide"
              class="img-fluid"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SetupConnectionModal",

  data() {
    return {
      organizationId: '',
      authToken: '',
      errors: {
        organizationId: '',
        authToken: ''
      },
      isLoading: false
    };
  },

  mounted() {
    this.eventHandler = () => {
      this.init();
    };

    $(document).on('open-setup-connection-modal', this.eventHandler);
  },

  beforeDestroy() {
    if (this.eventHandler) {
      $(document).off('open-setup-connection-modal', this.eventHandler);
    }
  },

  methods: {
    init() {
      window.modalIsOpen = true;

      $('#setup-connection-modal').modal('show');
    },

    handleClose() {
      window.modalIsOpen = false;

      const activeElement = document.activeElement;
      if (activeElement && activeElement !== document.body && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }

      $('#setup-connection-modal').modal('hide');
    },

    validateForm() {
      this.errors = {
        organizationId: '',
        authToken: ''
      };

      let isValid = true;

      if (!this.organizationId.trim()) {
        this.errors.organizationId = 'Organization ID is required';
        isValid = false;
      }

      if (!this.authToken.trim()) {
        this.errors.authToken = 'API Key is required';
        isValid = false;
      }

      return isValid;
    },

    async handleConfirm() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      try {
        const { data } = await axios.post('/salsify/setup-connection', {
          organization_id: this.organizationId,
          auth_token: this.authToken
        });

        if (data.status === 'error') {
          toastr.error(data.message);

          return;
        }

        if (data.status === 'success') {
          toastr.success(data.message);

          $(document).trigger('connection-setup-complete');

          this.handleClose();
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Failed to setup connection. Please try again.';

        console.error(errorMessage);
        toastr.error(errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    showInfoModal(event) {
      event.preventDefault();
      $('#salsify-info-modal').modal('show');
    },

    hideInfoModal() {
      const activeElement = document.activeElement;

      if (activeElement && activeElement !== document.body && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }

      $('#salsify-info-modal').modal('hide');
    }
  }
}
</script>

<style scoped>
  .info-btn {
    color:#495057 !important;
  }
</style>
